<div class="portal-page-content">
  @if (loading) {
    <div class="waiting-spinner">
      <mat-spinner strokeWidth="2" diameter="50"></mat-spinner>
      <p>Loading...</p>
    </div>
  }
  @if (!loading && profile) {
    <h2>Your Profile Information</h2>
    <div
      fxLayout="row"
      fxLayout.lt-lg="column"
      fxLayoutGap="20px"
      fxLayoutGap.lt-lg="10px"
    >
      <div fxFlex="50">
        <div fxLayout="column" fxLayoutGap="10px">
          @for (profilePanel of leftPanels; track profilePanel) {
            <section class="page-section">
              <div class="mt-1 header-row">
                <h3 class="header-text">{{ profilePanel.panelName }}</h3>
              </div>
              <table class="info-table">
                @for (field of profilePanel.profilePageFields; track field) {
                  <tr>
                    @if (field.fieldType !== 'CustomField') {
                      <app-portal-profile-system-fields
                        [field]="field"
                        [profile]="profile"
                        [addEmailFn]="addEmailFn"
                        [deleteEmailFn]="deleteEmailFn"
                        [makePrimaryEmailFn]="makePrimaryEmailFn"
                        (verifyEmail)="onVerifyEmail($event)"
                      >
                      </app-portal-profile-system-fields>
                    }
                  </tr>
                  @if (field.fieldType === 'CustomField') {
                    <tr>
                      <profile-custom-field-editor
                        [customFieldValues]="
                          getCustomFieldValueByTypeId(
                            field.customFieldDefinitionId
                          )
                        "
                        [customField]="
                          getCustomField(field.customFieldDefinitionId)
                        "
                        [id]="getCustomField(field.customFieldDefinitionId)?.id"
                        [genericAttributeService]="
                          getPortalProfileCustomFieldService(
                            getCustomField(field.customFieldDefinitionId)
                          )
                        "
                        [readOnly]="field.readOnly"
                      >
                      </profile-custom-field-editor>
                    </tr>
                  }
                }
              </table>
            </section>
          }
        </div>
      </div>
      <div fxFlex="50">
        <div fxLayout="column" fxLayoutGap="10px">
          @for (profilePanel of rightPanels; track profilePanel) {
            <section class="page-section">
              <div class="mt-1 header-row">
                <h3 class="header-text">{{ profilePanel.panelName }}</h3>
              </div>
              <table class="info-table">
                @for (field of profilePanel.profilePageFields; track field) {
                  <tr>
                    @if (field.fieldType !== 'CustomField') {
                      <app-portal-profile-system-fields
                        [field]="field"
                        [profile]="profile"
                        [addEmailFn]="addEmailFn"
                        [deleteEmailFn]="deleteEmailFn"
                        [makePrimaryEmailFn]="makePrimaryEmailFn"
                        (verifyEmail)="onVerifyEmail($event)"
                      >
                      </app-portal-profile-system-fields>
                    }
                  </tr>
                  @if (field.fieldType === 'CustomField') {
                    <tr>
                      <profile-custom-field-editor
                        [customFieldValues]="
                          getCustomFieldValueByTypeId(
                            field.customFieldDefinitionId
                          )
                        "
                        [customField]="
                          getCustomField(field.customFieldDefinitionId)
                        "
                        [id]="getCustomField(field.customFieldDefinitionId)?.id"
                        [genericAttributeService]="
                          getPortalProfileCustomFieldService(
                            getCustomField(field.customFieldDefinitionId)
                          )
                        "
                        [readOnly]="field.readOnly"
                      >
                      </profile-custom-field-editor>
                    </tr>
                  }
                }
              </table>
            </section>
          }
        </div>
      </div>
    </div>
  }
</div>
